

import Effect from "../Effect";
class EQ extends Effect {

	constructor(path, number) {
		super("EQ", EQ.nice_name, path, number);

		this.createParameter("bass", {name: "bass", min: -30, max: 30, step: 1 });
		this.createParameter("middle", {name: "middle", min: -30, max: 30, step: 1});
		this.createParameter("treble", {name: "treble", min: -30, max: 30, step: 1});
		this.createParameter("presence", {name: "presence", min: -30, max: 30, step: 1});
	}

	createNodes(context) {


		this.bass     = context.createBiquadFilter();
		this.middle   = context.createBiquadFilter();
		this.treble   = context.createBiquadFilter();
		this.presence = context.createBiquadFilter();

		// Set filter type
		this.bass.type     =  'lowshelf';
		this.middle.type   =  'peaking';
		this.treble.type   =  'peaking';
		this.presence.type = 'highshelf';

		// Set cutoff frequency
		this.bass.frequency.value     =  500;  // 500 Hz
		this.middle.frequency.value   = 1000;  // 1 kHz
		this.treble.frequency.value   = 2000;  // 2 kHz
		this.presence.frequency.value = 4000;  // 4 kHz

		// Set Q
		// this.bass.Q.value     = Math.SQRT1_2;  // Not used
		this.middle.Q.value   = Math.SQRT1_2;
		this.treble.Q.value   = Math.SQRT1_2;
		// this.presence.Q.value = Math.SQRT1_2;  // Not used

		// Set Gain
		this.bass.gain.value     = 0;
		this.middle.gain.value   = 0;
		this.treble.gain.value   = 0;
		this.presence.gain.value = 0;

		this.getParameterByName('bass').setParam(this.bass.gain);
		this.getParameterByName('middle').setParam(this.middle.gain);
		this.getParameterByName('treble').setParam(this.treble.gain);
		this.getParameterByName('presence').setParam(this.presence.gain);

		this.bass.connect(this.middle);
		this.middle.connect(this.treble);
		this.treble.connect(this.presence);

		return {
			connect: (node) => {
				this.presence.connect(node);
			},
			disconnect: (node) => {
				this.presence.disconnect(node);
			},
			input: this.bass
		};
	}
}

EQ.nice_name = "Equalizer";

export default EQ;
